import Axios from "axios";
import { RequestApprovalT, ApprovalT } from "./Approval";
// export const ApprovalDomain = `${process.env.REACT_APP_DIALOG_API}/approval`
const DateTimeFormat = (date: Date) => {
  var month_names = [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
    ]
    var day = date.getDate()
    var month_index = date.getMonth()
    var year = date.getFullYear()
    let hours = date.getHours()
    let minutes = date.getMinutes()
    const ampm = (hours >= 12 ? 'pm' : 'am').toUpperCase()
    hours = hours % 12
    hours = hours ? hours : 12
    const minutesInString = minutes < 10 ? '0' + minutes : minutes.toString()
    return `${day}-${month_names[month_index]}-${year} ${hours}:${minutesInString} ${ampm}`
}
export const ExpiryDateFormat = (approval: ApprovalT) => {
    let date = new Date(approval.createdDate)
    let getDays = approval.expiry.days ? approval.expiry.days : 0
    let getHours = approval.expiry.hours ? approval.expiry.hours : 0
    let getMinutes = approval.expiry.minutes ? approval.expiry.minutes : 0
    console.log('exproitr date :: 1', date, getDays, getHours, getMinutes)
    date.setDate(date.getDate() + Number(getDays))
    date.setHours(date.getHours() + Number(getHours))
    date.setMinutes(date.getMinutes() + Number(getMinutes))

    console.log('exproitr date :: 2', date)
    return DateTimeFormat(date)
}
export const CreatedDateFormat = (dateInString: string) => {
  const date = new Date(dateInString);
  return DateTimeFormat(date);
};
const ApprovalDomain = `${window.location.origin}/approval`
const approvalStatus = `${ApprovalDomain}/approval/status`;
const updateapproval = `${ApprovalDomain}/approval/update`;
export const GetApprovalRequest = (obj: {
  requestId: string;
  approvalId: string;
}) => Axios.post(approvalStatus, obj);
export const UpdateApproval = (data: RequestApprovalT) =>
  Axios.post(updateapproval, data);
